import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { IoMdReturnLeft } from "react-icons/io";
import { server } from "../common";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelectAccess } from "../store/stateFunctions";

const initialValues = {
  title: "",
  descr: "",
  images: [], // ✅ single image नाही → multiple images
};

const initialValues2 = {
  new_priority: "",
};

const swalalert = withReactContent(Swal);

const AddNews = ({ role }) => {
  const user = useSelectAccess("Super Admin");
  const token = localStorage.getItem("superadminToken");

  const [showmodel, setShowModel] = useState(false);
  const [arrangedata, setArrangeData] = useState(null);
  const handleshowSequence = (item) => {
    setShowModel(true);
    setArrangeData(item);
  };

  const handleCloseSequence = () => setShowModel(false);

  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setIsEditMode(false);
    setSelectedData(null);
    formik.resetForm();
  };
  const handleShow = () => {
    setIsEditMode(false);
    setSelectedData(null);
    formik.resetForm();
    setShow(true);
  };

  const handleShowEdit = (data) => {
    setSelectedData(data);
    setIsEditMode(true);
    setShow(true);
  };

  useEffect(() => {
    getData();
  }, []);

  // Update form values when entering edit mode
  useEffect(() => {
    if (isEditMode && selectedData) {
      formik.setValues({
        title: selectedData.title || "",
        descr: selectedData.description || selectedData.descr || "", // Handle both field names
        images: [], // Keep empty - user can optionally upload new images
      });
    } else if (!isEditMode) {
      formik.setValues(initialValues);
    }
  }, [isEditMode, selectedData]);

  // Get
  const getData = () => {
    server
      .get("/csr/getallcsr", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete
  const deleteNews = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/csr/deletecsr/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: token,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "News has been deleted.", "success");
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // update news
  const handleUpdate = (values) => {
    const formData = new FormData();
    let hasUpdates = false;
    
    // Only append fields that have values (not empty)
    if (values.title && values.title.trim()) {
      formData.append("title", values.title.trim());
      hasUpdates = true;
    }
    
    if (values.descr && values.descr.trim()) {
      formData.append("description", values.descr.trim());
      hasUpdates = true;
    }

    // Handle multiple images if provided
    if (values.images && values.images.length > 0) {
      for (let i = 0; i < values.images.length; i++) {
        formData.append("images", values.images[i]);
      }
      hasUpdates = true;
    }

    // Check if at least one field is being updated
    if (!hasUpdates) {
      toast.error("Please update at least one field");
      return;
    }

    const updateToken = user?.authToken || token;
    server
      .put(`/csr/updatecsr/${selectedData.id}`, formData, {
        headers: {
          Authorization: updateToken,
          // Don't set Content-Type manually for FormData - axios will set it automatically with boundary
        },
      })
      .then(function (response) {
        formik.resetForm();
        getData();
        toast.success("CSR Updated successfully");
        handleClose();
        setIsEditMode(false);
        setSelectedData(null);
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  //add
  //   const formik = useFormik({
  //     initialValues: isEditMode ? selectedData : initialValues,
  //     validationSchema: Yup.object({
  //       title: Yup.string().required("Enter a News title"),
  //       descr: Yup.string().required("Enter a News descr"),
  //       image: Yup.mixed()
  //         .required("Please select an image")
  //         .test(
  //           "fileSize",
  //           "Image size must be less than 1MB",
  //           (value) => value && value.size <= 1048576 // 1MB in bytes
  //         ),
  //     }),
  //     onSubmit: (values, action) => {
  //       if (isEditMode) {
  //         handleUpdate({ ...values, id: selectedData.id });
  //       } else {
  //         if (!values.image) {
  //           toast.error("Please select a images");
  //           return;
  //         }
  //         const formData = new FormData();
  //         formData.append("title", values.title);
  //         formData.append("descr", values.descr);
  //         formData.append("image", values.image);
  //         console.log(formData,"formDataformDataformDataformData");

  //         server
  //           .post("/csr/addcsr", {
  // formData
  //           }, {
  //             headers: {
  //           Authorization: token,
  //             },
  //           })
  //           .then(function (response) {
  //             if (response.status === 200 || response.status === 201) {
  //               toast.success("News Added successfully");
  //               formik.resetForm();
  //               handleClose();
  //               getData();
  //             }
  //           })
  //           .catch(function (error) {
  //             if (error.response?.data?.message)
  //               toast.error(error.response.data.message);
  //             else if (error.response?.data?.error) {
  //               toast.error(error.response.data.error);
  //             } else toast.error("Failed to connect to server");
  //           });
  //       }
  //     },
  //   });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      title: Yup.string()
        .when("$isEditMode", {
          is: false,
          then: (schema) => schema.required("Enter a News title"),
        }),
      descr: Yup.string()
        .when("$isEditMode", {
          is: false,
          then: (schema) => schema.required("Enter a News description"),
        }),
      images: Yup.mixed()
        .nullable()
        .test(
          "fileSize",
          "Each image must be less than 1MB",
          (value) => !value || (value.length && [...value].every((file) => file.size <= 1048576))
        )
        .when("$isEditMode", {
          is: false,
          then: (schema) => schema.required("Please select at least one image"),
        }),
    }),
    onSubmit: (values, action) => {
      if (isEditMode) {
        // Update existing record - all fields are optional
        // Only send fields that have values
        handleUpdate(values);
      } else {
        // Add new record
        if (!values.images || values.images.length === 0) {
          toast.error("Please select at least one image");
          return;
        }
        const formData = new FormData();
        formData.append("title", values.title);
        formData.append("description", values.descr);
        for (let i = 0; i < values.images.length; i++) {
          formData.append("images", values.images[i]); // ✅ multiple files
        }

        // ✅ Correct way: send FormData directly
        server
          .post("/csr/addcsr", formData, {
            headers: {
              Authorization: token,
            },
          })
          .then((response) => {
            toast.success("CSR Added successfully");
            action.resetForm();
            handleClose();
            getData();
          })
          .catch((error) => {
            if (error.response?.data?.error) {
              toast.error(error.response.data.error);
            } else {
              toast.error("Failed to connect to server");
            }
          });
      }
    },
  });

  //add
  const formiks = useFormik({
    initialValues: initialValues2,
    onSubmit: (values, action) => {
      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("description", values.descr);

      // ✅ append multiple images
      for (let i = 0; i < values.images.length; i++) {
        formData.append("images", values.images[i]);
      }

      server
        .post("/csr/addcsr", formData, {
          headers: {
            Authorization: token,
          },
        })
        .then((response) => {
          toast.success("News Added successfully");
          action.resetForm();
          handleClose();
          getData(); // refresh list
        })
        .catch((error) => {
          if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else {
            toast.error("Failed to connect to server");
          }
        });
    },
  });

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/news/searchnews?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/news/newsfilter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user?.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      {console.log(formik.values)}
      <div className="container">
        {/* <div className="row my-3">
          <div className="col-md-4">
            <input
              type="search"
              className="form-control"
              placeholder="Search "
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <select
              className="form-control"
              name=""
              id=""
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option value="2days" defaultValue>
                Last 2 days
              </option>
              <option value="month" defaultValue>
                This Month
              </option>
              <option value="3months">Last 3 Months</option>
              <option value="6months">Last 6 Months</option>
            </select>
          </div>
        </div> */}
        <div className="d-flex position-relative mb-3 mt-5 justify-content-center ">
          <h5 className="m-auto text-center">CSR Intiatives</h5>
          <Button variant="contained" color="info" onClick={handleShow}>
            Add CSR Intiatives
          </Button>

          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditMode ? "Edit News Details" : "Add News Details"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={formik.handleSubmit}>
                <div className="form-outline mb-2">
                  <TextField
                    name="title"
                    margin="dense"
                    type="text"
                    placeholder="Title"
                    variant="outlined"
                    label="News Title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    fullWidth
                    required={!isEditMode}
                  ></TextField>
                  {formik.errors.title ? (
                    <p className="text-danger">{formik.errors.title}</p>
                  ) : null}
                </div>

                <div className="form-outline mb-2">
                  <TextField
                    name="images"
                    margin="dense"
                    type="file"
                    variant="outlined"
                    label={isEditMode ? "News Images (Optional - leave empty to keep existing)" : "News Images"}
                    fullWidth
                    inputProps={{
                      accept: ".jpg, .png, .jpeg",
                      multiple: true, // ✅ allow multiple
                    }}
                    onChange={(event) =>
                      formik.setFieldValue("images", event.currentTarget.files)
                    }
                  />
                  {formik.errors.images ? (
                    <p className="text-danger">{formik.errors.images}</p>
                  ) : null}
                  {isEditMode && (
                    <p className="text-muted small mt-1">
                      Leave empty to keep existing images. Select new images to replace them.
                    </p>
                  )}
                </div>

                <div className="form-outline mb-2">
                  <TextField
                    name="descr"
                    margin="dense"
                    type="text"
                    placeholder="Description"
                    variant="outlined"
                    label="Description"
                    value={formik.values.descr}
                    onChange={formik.handleChange}
                    fullWidth
                    required={!isEditMode}
                    multiline
                    rows={4}
                  ></TextField>
                  {formik.errors.descr ? (
                    <p className="text-danger">{formik.errors.descr}</p>
                  ) : null}
                </div>

                <div className="pt-1 mb-2 ">
                  <Button variant="contained" type="submit">
                    {isEditMode ? "Update" : "Post"}
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </div>
        <div className="container" style={{ overflow: "scroll" }}>
          <table className="table table-striped border">
            <thead>
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Title</th>
                <th scope="col">Description</th>
                <th scope="col">Images</th>
                <th scope="col">Update</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.description}</td>
                    <td>
                      {item.image &&
                        (() => {
                          try {
                            // Check if image is already an array (from backend processing)
                            let imageArray = item.image;
                            if (typeof item.image === 'string' && item.image.trim()) {
                              // Try to parse JSON string
                              try {
                                imageArray = JSON.parse(item.image);
                              } catch (parseErr) {
                                // If not JSON, treat as single string
                                imageArray = [item.image];
                              }
                            }
                            
                            // Ensure it's an array and filter out invalid values
                            if (!Array.isArray(imageArray)) {
                              imageArray = [];
                            }
                            
                            imageArray = imageArray.filter(img => img && typeof img === 'string' && img.trim());
                            
                            if (imageArray.length > 0) {
                              return imageArray.map((img, idx) => {
                                if (!img || typeof img !== 'string') return null;
                                
                                // Fix image path - handle both localhost and production URLs
                                let fixedImg = img.trim();
                                
                                // Remove double slashes
                                fixedImg = fixedImg.replace(/([^:]\/)\/+/g, '$1');
                                
                                // If URL already has correct path (/public/uploads/), keep as is
                                // Otherwise, fix /backend/ paths
                                if (fixedImg.includes('/backend/')) {
                                  fixedImg = fixedImg.replace(/\/backend\//g, '/public/uploads/');
                                }
                                
                                // If URL starts with http/https and has correct path, use as is
                                // For production URLs, preserve them
                                if ((fixedImg.startsWith('http://') || fixedImg.startsWith('https://')) && fixedImg.includes('/public/uploads/')) {
                                  // Already correct production or localhost URL
                                } else if (fixedImg.startsWith('http://') || fixedImg.startsWith('https://')) {
                                  // Has protocol but wrong path - fix it
                                  fixedImg = fixedImg.replace(/\/backend\//g, '/public/uploads/');
                                } else {
                                  // Relative path - extract filename
                                  const filename = fixedImg.split('/').pop();
                                  if (filename) {
                                    // Use current window location for relative paths
                                    const currentHost = window.location.origin;
                                    fixedImg = `${currentHost}/public/uploads/${filename}`;
                                  }
                                }
                                
                                // Clean up any remaining issues
                                fixedImg = fixedImg.replace(/undefined/g, '').replace(/\/\/+/g, '/');
                                
                                // Skip if image is still invalid
                                if (!fixedImg || fixedImg.includes('undefined') || fixedImg.length < 10) {
                                  return null;
                                }
                                
                                return (
                                  <a key={idx} href={fixedImg} target="_blank" rel="noreferrer" className="me-1">
                                    <img 
                                      width="50" 
                                      height="50" 
                                      src={fixedImg} 
                                      alt={`csr-img-${idx}`} 
                                      style={{ objectFit: 'cover' }}
                                      onError={(e) => {
                                        console.error('Image load error:', fixedImg);
                                        e.target.style.display = 'none';
                                      }}
                                    />
                                  </a>
                                );
                              }).filter(Boolean); // Remove null entries
                            }
                            
                            return <span className="text-muted">No images</span>;
                          } catch (e) {
                            console.error("Image display error:", e);
                            return <span className="text-muted">Error loading images</span>;
                          }
                        })()}
                      {!item.image && <span className="text-muted">No images</span>}
                    </td>


                    <td>
                      <div className="btn btn-success text-white">
                        <AiFillEdit onClick={() => handleShowEdit(item)} />
                      </div>
                    </td>
                    <td>
                      <div className="btn btn-danger text-white">
                        <AiFillDelete onClick={() => deleteNews(item)} />
                      </div>
                    </td>
                    {/* <td>
                      <div
                        className="btn btn-info text-white text-center"
                        onClick={() => handleshowSequence(item)}
                      >
                        {item.priority}
                      </div>
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <Modal show={showmodel} onHide={() => setShowModel(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Sequence</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formiks.handleSubmit}>
            <div className="form-outline mb-2">
              <TextField
                name="new_priority"
                margin="dense"
                type="text"
                placeholder="Title"
                variant="outlined"
                label="Number"
                value={formiks.values.new_priority}
                onChange={formiks.handleChange}
                fullWidth
                required
              ></TextField>
              {formiks.errors.new_priority ? (
                <p className="text-danger">{formiks.errors.new_priority}</p>
              ) : null}
            </div>

            <div className="pt-1 mb-2 ">
              <Button variant="contained" type="submit">
                Update
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddNews;
